import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { TypeChangeModalProps } from '../../types/competition';

/**
 * Modal to confirm routine type changes when dancer count changes
 */
const TypeChangeModal: React.FC<TypeChangeModalProps> = ({ 
  show, 
  typeChangeInfo, 
  onConfirm, 
  onCancel, 
  isDarkMode 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className={`w-full max-w-md rounded-lg shadow-xl ${
        isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"
      }`}>
        <div className={`flex items-center p-4 border-b ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}>
          <AlertTriangle className={`h-5 w-5 mr-2 ${
            isDarkMode ? "text-yellow-400" : "text-yellow-500"
          }`} />
          <h3 className="text-lg font-semibold">Routine Type Change</h3>
        </div>
        
        <div className="p-4">
          <p className="mb-4">
            This change will modify the routine type from <span className="font-semibold text-yellow-500">{typeChangeInfo.oldType}</span> to <span className="font-semibold text-blue-500">{typeChangeInfo.newType}</span> due to the number of dancers.
          </p>
          <p className="mb-4">
            This may affect competition categories and pricing. Do you want to continue with this change?
          </p>
          
          <div className="flex justify-end space-x-3">
            <button
              onClick={onCancel}
              className={`px-4 py-2 rounded-lg ${
                isDarkMode
                  ? "bg-gray-700 text-gray-300 hover:bg-gray-600"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`px-4 py-2 rounded-lg ${
                isDarkMode
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypeChangeModal; 